import { SimpleChanges } from '@angular/core';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { NguoicocongService } from 'src/app/data/service/nguoicocong.service';

export const INITIAL_DATA: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LimsReportViewerComponent),
    multi: true
};

@Component({
    selector: 'lims-report-viewer',
    templateUrl: './lims-report-viewer.component.html',
    styleUrls: ['./lims-report-viewer.component.scss'],
    providers: [INITIAL_DATA]
})
export class LimsReportViewerComponent implements OnInit, ControlValueAccessor {

    @Input()
    public label: string;

    @Input()
    public placeholder: string;

    @Input()
    public selectedItem: string;

    @Input()
    public data: any[];

    @Input()
    public allItemLabel: string;

    @Input()
    public disableAllItem: boolean = false;

    @Input()
    public formControl: FormControl;

    @Input()
    public keyId: string;

    @Input()
    public keyName: string;

    @Input()
    public class: string;

    @Input()
    public error: any;

    @Input()
    public multiple: boolean;

    @Input()
    public noEntriesFoundLabel: string;

    reportServer: string = '';
    reportUrl: string = '/reports/NCC/Blank_A4';
    showParameters: string = "true";
    parameters: any = {
        "nam": 2019
    };
    language: string = "en-us";
    width: number = 100;
    height: number = 100;
    toolbar: string = "true";

    @Output() selected: EventEmitter<any> = new EventEmitter();
    @Output() objectSelected: EventEmitter<any> = new EventEmitter();

    public onModelChange: Function = () => { };
    public onModelTouched: Function = () => { };

    /** Subject that emits when the component has been destroyed. */
    private _onDestroy = new Subject<void>();

    constructor(private service: NguoicocongService) {
        // this.service.getEncryptionKey().subscribe(() => {
            
        // });
        // this.service.getLoginKey().subscribe(() => {
                
        // });
    }
    ngOnInit() {

    }

    ngAfterViewInit() {
        
    }

    ngOnChanges(changes: SimpleChanges) {
        // only run when property "data" changed
        if (changes['data']) {
            this.ngOnInit();
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    writeValue(obj: any): void {
        this.onModelChange(obj);
    }
    registerOnChange(fn: Function): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        // throw new Error('Method not implemented.');
    }

    changeValue() {
        if (this.selected) this.selected.emit();
    }
}
